module.exports = __webpack_public_path__ + "static/media/status-I.1a8fc11b.svg";